import { render, staticRenderFns } from "./SectionMaterialFile.vue?vue&type=template&id=b7fac446&scoped=true"
import script from "./SectionMaterialFile.vue?vue&type=script&lang=js"
export * from "./SectionMaterialFile.vue?vue&type=script&lang=js"
import style0 from "./SectionMaterialFile.vue?vue&type=style&index=0&id=b7fac446&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fac446",
  null
  
)

export default component.exports